// extracted by mini-css-extract-plugin
export default {"green":"Ctable_green__WT6hE","red":"Ctable_red__rRklr","clickable":"Ctable_clickable__xj+fj"};